module.exports = __webpack_public_path__ + "static/media/java.0e90a4fe.png";